import styles from './RequiredLessonMaterials.module.scss';
import Modal from 'src/components/modal/Modal';
import Button from 'src/components/button/Button';
import { LordIcon } from '@src/components/lord-icon/lord-icon';
import { IconInfo } from '@src/constants';
import MaterialCard from '@src/components/materialCard/Card';
import { useCallback, useMemo } from 'react';
import { hasArrayValues } from '@src/utils/helpers';
import { Content, Lesson, LessonFragment } from '@src/api/graphql-codegen';

type Props = {
  open: boolean;
  lesson?: LessonFragment;
  onClose: () => void;
  onStartLesson: () => void;
  openMaterial: () => void;
  startLabel?: string;
  handleDownloadMaterial?: (content: Content, lesson: Lesson, needPrint?: boolean) => void;
};

function RequiredUnitLessonMaterials(props: Props) {
  const { open, lesson, startLabel, onClose, onStartLesson, handleDownloadMaterial } = props;

  const requiredMaterials = useMemo(() => {
    if (!lesson?.materials) return [];
    return lesson?.materials.filter(material => material?.isRequired === true)
}, [lesson?.materials])

const optionalMaterials = useMemo(() => {
    if (!lesson?.materials) return [];
    return lesson?.materials.filter(material => material?.isRequired === false)
}, [lesson?.materials])

  const handleDownloadLessonMaterial = useCallback((content: Content) => {
    handleDownloadMaterial?.(content, lesson as Lesson);
  }, [lesson, handleDownloadMaterial]);

  const handlePrintMaterial = useCallback((content: Content) => {
    handleDownloadMaterial?.(content, lesson as Lesson, true);
  }, [lesson, handleDownloadMaterial]);

  return (
    <Modal global={false} open={open} onClose={onClose} closeButton={false} className={styles.wrapper}>
      <div className={styles.mainView}>
        <div className={styles.header}>
          <div className={styles.title}>{'Lesson Materials'}</div>
        </div>
        <div className={styles.content}>
          <div className={styles.normalText}>{'Please ensure you have downloaded the required materials for this lesson.'}</div>
          <div className={styles.subView}>
            {hasArrayValues(requiredMaterials) && <div className={styles.materialContents}>
              <div className={styles.requireTitle}>
                Required
                <LordIcon src={IconInfo} isHover={true} colors={{primary: '#FFB073', secondary: '#FFB073'}} size={20}/>
              </div>
              <div className={styles.unitsDiv}>
              {requiredMaterials.map((material, index) => {
                return (
                  <MaterialCard key={index} content={material} handleDownloadMaterial={handleDownloadLessonMaterial} handlePrintMaterial={handlePrintMaterial}/>
                )
              })}
              </div>
            </div>}
            {hasArrayValues(optionalMaterials) && <div className={styles.materialContents}>
              <div className={styles.optionTitle}>
                Optional
                <LordIcon src={IconInfo} isHover={true} colors={{primary: '#6C969A', secondary: '#6C969A'}} size={20}/>
              </div>
              <div className={styles.unitsDiv}>
              {optionalMaterials.map((material, index) => {
                return (
                  <MaterialCard key={index} content={material} handleDownloadMaterial={handleDownloadLessonMaterial} handlePrintMaterial={handlePrintMaterial}/>
                )
              })}
              </div>
            </div>}
          </div>
          <div className={styles.action}>
            <Button className={styles.downButton} onClick={onClose} label={'Cancel'}/>
            <Button className={styles.startButton} onClick={onStartLesson} label={startLabel ? startLabel : 'Begin Lesson'}/>
          </div>
        </div>
      </div>
    </Modal>
  );
}

export default RequiredUnitLessonMaterials;
